import React, { useState, useEffect } from 'react';
import { Tabs, Tab, Box, Typography } from '@mui/material';

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;
  useEffect(() => {
    document.title = "Our Services - Pest Control Raipur Services";
  }, []);
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

export const Services = () => {
  const [value, setValue] = useState(0);

  useEffect(() => {
    document.title = "Services - Pest Control Raipur Services";
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs value={value} onChange={handleChange} centered>
        <Tab label="Residential Services" />
        <Tab label="Commercial Services" />
      </Tabs>
      <TabPanel value={value} index={0}>
        <Typography variant="h4" gutterBottom>Residential Services</Typography>
        <ul className="list-disc pl-6 text-lg text-gray-700">
          <li>Termite Treatment</li>
          <li>Cockroach Treatment</li>
          <li>Sanitization</li>
          <li>Rodent Control</li>
          <li>Bed Bug Treatment</li>
        </ul>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Typography variant="h4" gutterBottom>Commercial Services</Typography>
        <ul className="list-disc pl-6 text-lg text-gray-700">
          <li>Office Sanitization</li>
          <li>Warehouse Pest Control</li>
          <li>Restaurant Pest Control</li>
          <li>Hotel Pest Control</li>
          <li>Industrial Pest Control</li>
        </ul>
      </TabPanel>
    </Box>
  );
};